import { useEffect, useRef, useState } from "react";
import { Box, Typography, Paper, Stack, Button, TextField, Alert } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import JsBarcode from "jsbarcode";
import { useSearchParams } from "react-router-dom";

export function BarcodePage() {
  const [params] = useSearchParams();
  const [value, setValue] = useState(params.get("value") ?? "");
  const [sub, setSub] = useState(params.get("sub") ?? "");
  const [err, setErr] = useState<string | null>(null);
  const svgRef = useRef<SVGSVGElement | null>(null);

  useEffect(() => {
    if (!svgRef.current || !value) return;
    try {
      JsBarcode(svgRef.current, value, { format: "CODE128", displayValue: true, height: 64, fontSize: 14, margin: 8 });
      setErr(null);
    } catch (e) {
      setErr(e instanceof Error ? e.message : "Could not render barcode");
    }
  }, [value, sub]);

  return (
    <Box>
      <style>{`@media print { .no-print { display: none !important; } .print-label { box-shadow: none !important; border: 1px dashed #999; } }`}</style>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }} className="no-print">Diagnostics · Barcode Label</Typography>

      <Paper sx={{ p: 2, mb: 2 }} className="no-print">
        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems="center">
          <TextField label="Barcode value (accession)" size="small" value={value} onChange={e => setValue(e.target.value)} sx={{ flexGrow: 1 }} />
          <TextField label="Sub-label (sample)" size="small" value={sub} onChange={e => setSub(e.target.value)} />
          <Button variant="contained" startIcon={<PrintIcon />} disabled={!value} onClick={() => window.print()}>Print</Button>
        </Stack>
        {err && <Alert severity="error" sx={{ mt: 2 }}>{err}</Alert>}
      </Paper>

      <Paper className="print-label" sx={{ p: 2, width: 320, textAlign: "center" }}>
        {value
          ? <svg ref={svgRef} />
          : <Typography variant="body2" color="text.secondary">Enter a barcode value above.</Typography>}
        {sub && <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>Sample {sub}</Typography>}
      </Paper>
    </Box>
  );
}
